window.initGoogleAddress = function () {
    if (!window.google) return;

    const inputs = document.querySelectorAll(
        "input.google-address-autocomplete:not([data-autocomplete-initialized])"
    );

    inputs.forEach(input => {
        input.dataset.autocompleteInitialized = "true";
        // Browsers often ignore autocomplete="off" on address fields and
        // show native autofill, which can block the Google Places dropdown.
        input.setAttribute("autocomplete", "new-password");
        input.setAttribute("autocorrect", "off");
        input.setAttribute("autocapitalize", "off");
        input.setAttribute("spellcheck", "false");
        input.setAttribute("data-lpignore", "true");

        if (!input.dataset.readonlyGuardBound) {
            input.setAttribute("readonly", "readonly");
            input.addEventListener("focus", () => {
                input.removeAttribute("readonly");
            }, { once: true });
            input.dataset.readonlyGuardBound = "true";
        }

        const autocomplete = new google.maps.places.Autocomplete(input, {
            types: ["address"],
            componentRestrictions: { country: "us" },
            fields: ["address_components", "geometry"]
        });

        autocomplete.addListener("place_changed", () => {
            const place = autocomplete.getPlace();
            if (!place.geometry || !place.address_components) return;

            const components = {};

            place.address_components.forEach(component => {
                component.types.forEach(type => {
                    components[type] = component;
                });
            });

            const getLong  = t => components[t]?.long_name  || "";
            const getShort = t => components[t]?.short_name || "";

            // 🔑 scope fields to the closest form (or container)
            const scope = input.closest(".address-section") || document;

            // const cityField = input.dataset.city;

            const city = getLong("locality") ||
                getLong("postal_town") ||
                getLong("sublocality_level_1");

            // if(cityField && city !== cityField) {
            //     $('#cityMismatchWarning').show();
            // } else {
            //     $('#cityMismatchWarning').hide();
            // }

            // not every address-section has every field (e.g. reporter address has no
            // county), and dispatching input lets other listeners (like required-field
            // validation) react to the programmatic fill the same way they would to typing
            const setFieldValue = (selector, value) => {
                const field = scope.querySelector(selector);
                if (!field) return;

                field.value = value;
                field.dispatchEvent(new Event("input", { bubbles: true }));
            };

            setFieldValue("#stateField", getLong("administrative_area_level_1"));
            setFieldValue("#countyField", getLong("administrative_area_level_2"));
            setFieldValue("#cityField", city);
            setFieldValue("#zipCodeField", getLong("postal_code"));
            setFieldValue("#suiteField", getLong("subpremise"));
            setFieldValue("#streetField", `${getLong("street_number")} ${getLong("route")}`.trim());
        });
    });
};

document.addEventListener("turbolinks:load", () => {
    window.initGoogleAddress?.();
});
